import { Component, OnInit, ViewChild } from '@angular/core';
import { iconPdf, iconBook, iconComment, iconLock, iconRss, rutaDocs, saveContent, docInstrucciones, DscMensajeSpinner, GlobalVars, cookieGlobalVars, cambiarRouter, ParametroVars } from 'src/app/general/variables';
import { ParametroService } from 'src/app/services/parametro.service';
import { Fur } from 'src/app/models/Fur';
import { FormularioWebComponent } from '../formulario-web.component';
import { ModalSeguimientoPpComponent } from '../modal-seguimiento-pp/modal-seguimiento-pp.component';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { Router } from '@angular/router';
import { General } from 'src/app/models/General';
import { UtilService } from 'src/app/services/util/util.service';
import { FrmUtilSADEncode } from 'src/app/models/util/FrmUtilSADEncode';
import { ModalTerminosComponent } from '../modal-terminos/modal-terminos/modal-terminos.component';

@Component({
  selector: 'app-panel-principal-fw',
  templateUrl: './panel-principal-fw.component.html',
  styleUrls: ['./panel-principal-fw.component.css']
})
export class PanelPrincipalFwComponent implements OnInit {

  strDscNroTelefCgr = '';
  strDscLinkInst = '';
  flgViewFw = false;
  flgViewInfoComp = false;
  flgViewPP = true;
  flgViewAcceda = false;
  iconPdf = iconPdf;
  iconBook = iconBook;
  iconComment = iconComment;
  iconLock = iconLock;
  iconRss = iconRss;
  generalParams: General;
  frmUtilSADEncode: FrmUtilSADEncode;
  DscMensajeSpinner = DscMensajeSpinner;
  strDscLinkAudPub = '#';
  strDscLinkMonitor = '#';
  strDscLinkAuditor = '#';
  strDscEnlaceApp = '';

  @ViewChild(FormularioWebComponent) FormularioWebC: FormularioWebComponent;

  constructor(protected parametroService: ParametroService,
              protected utilService: UtilService,

              public dialog: MatDialog,
              public router: Router) { }

  ngOnInit() {


    // try {

    //   setTimeout(() => {

    //     this.loadFormAssets().then(() => {console.log("Script Loaded");})
    //     .catch(() => {

    //       console.log("Script Problem");

    //     });

    //   }, 600);

    // } catch (e) {

    //   setTimeout(() => {

    //     this.loadFormAssets().then(() => {console.log("Script Loaded");})
    //     .catch(() => {

    //       console.log("Script Problem");

    //     });

    //   }, 600);

    // }

    // this.parametroService.obtenerParametro(NumIdParamLinkApp).subscribe(
    //   data => {

    //     this.strDscEnlaceApp = data.cparamValor;

    //   });

    this.strDscEnlaceApp = ParametroVars.Param17;


    // this.parametroService.obtenerParametro(6).subscribe(
    //   data => {

    //     if(data)
    //     {
    //       this.strDscNroTelefCgr = data.cparamValor;
    //     }

    //   });

    this.strDscNroTelefCgr = ParametroVars.Param6;

    // this.parametroService.obtenerParametro(18).subscribe(
    //   data => {

    //     if(data)
    //     {
    //       this.strDscLinkInst = data.cparamValor;
    //     }



    //   });

    this.strDscLinkInst = ParametroVars.Param18;

    // this.parametroService.obtenerParametro(27).subscribe(
    //   data => {

    //     if(data)
    //     {
    //       this.strDscLinkAudPub = data.cparamValor;
    //     }



    //   });

    this.strDscLinkAudPub = ParametroVars.Param27;

    // this.parametroService.obtenerParametro(28).subscribe(
    //   data => {

    //     if(data)
    //     {
    //       this.strDscLinkMonitor = data.cparamValor;
    //     }



    //   });

    this.strDscLinkMonitor = ParametroVars.Param28;

    // this.parametroService.obtenerParametro(29).subscribe(
    //   data => {

    //     if(data)
    //     {
    //       this.strDscLinkAuditor = data.cparamValor;
    //     }



    //   });

    this.strDscLinkAuditor = ParametroVars.Param29;

    // let url : string = this.router.url;
    // let posFW : number = url.indexOf(DscPathFwExt);
    // let posPath:number = 0;
    // let idInstancia:string = "";

    // console.log("===this.router",this.router);
    // console.log(window.location.href);

    // if(posFW > 0)
    // {

    //   posPath = url.lastIndexOf("/");

    //   idInstancia = url.substring(posPath + 1);

    //   this.frmUtilSADEncode = new FrmUtilSADEncode();
    //   this.frmUtilSADEncode.flagEncodDecod = 2;
    //   this.frmUtilSADEncode.textoEntrada = idInstancia;

    //   console.log("this.frmUtilSADEncode",this.frmUtilSADEncode);

    //   this.utilService.encode(this.frmUtilSADEncode).subscribe(data => {

    //     this._denuncia(3);

    //     setTimeout(() => {

    //       this.generalParams = new General();

    //       this.generalParams.flgCampo1 = true;
    //       this.generalParams.numCampo1 = Number(data.resultado);

    //       console.log("======this.generalParams",this.generalParams);

    //       console.log("======this.generalParams1");

    //       this.FormularioWebC.setGeneralParams(this.generalParams);

    //     }, 0);

    //   });



    // }else{


    //   this.parametroService.obtenerParametro(6).subscribe(
    //     data => {

    //       if(data)
    //       {
    //         this.strDscNroTelefCgr = data.cparamValor;
    //       }

    //     });

    //   this.parametroService.obtenerParametro(18).subscribe(
    //     data => {

    //       if(data)
    //       {
    //         this.strDscLinkInst = data.cparamValor;
    //       }



    //     });

    //     this.parametroService.obtenerParametro(27).subscribe(
    //       data => {

    //         if(data)
    //         {
    //           this.strDscLinkAudPub = data.cparamValor;
    //         }



    //       });

    //     this.parametroService.obtenerParametro(28).subscribe(
    //       data => {

    //         if(data)
    //         {
    //           this.strDscLinkMonitor = data.cparamValor;
    //         }



    //       });

    //     this.parametroService.obtenerParametro(29).subscribe(
    //       data => {

    //         if(data)
    //         {
    //           this.strDscLinkAuditor = data.cparamValor;
    //         }



    //       });

    // }




  }

  _resetFlags() {

    this.flgViewFw = false;
    this.flgViewPP = false;
    this.flgViewAcceda = false;
    this.flgViewInfoComp = false;

  }

  // loadFormAssets() {
  //   return new Promise(resolve => {

  //     const scriptElement = document.createElement('script');
  //     scriptElement.src = "assets/js/captcha.js";
  //     scriptElement.onload = resolve;
  //     document.body.appendChild(scriptElement);

  //     const scriptElement1 = document.createElement('script');
  //     scriptElement1.src = "assets/js/document-captcha.js";
  //     scriptElement1.onload = resolve;
  //     scriptElement1.async = true;
  //     scriptElement1.defer = true;
  //     document.body.appendChild(scriptElement1);

  //   });
  // }

  _accesoFormularios(numCaso: number) {

    this._resetFlags();

    switch (numCaso) {
      case 1:

        // this.flgViewFw = true;

        GlobalVars.objetoFurAcceda = null;
        GlobalVars.FlgNuevoFw = true;

        cookieGlobalVars(3);

        cambiarRouter(this.router, 3);

        break;

      case 2:

        this.flgViewInfoComp = true;

        break;

      default:
        break;
    }



  }

  _registraDenuncia() {

    this._denuncia(2);


  }



  _denuncia(numCaso: number) {

    switch (numCaso) {
      case 1:

        this._accesoFormularios(1); // FW

        break;
      case 2:


        // let dataResult: General;

        const configuracionGlobal = new MatDialogConfig();

        configuracionGlobal.disableClose = true;
        configuracionGlobal.autoFocus = true;

        configuracionGlobal.width = '80%';

        const dialogRef = this.dialog.open(ModalTerminosComponent, configuracionGlobal);

        dialogRef.afterClosed().subscribe(result => {


          if (result == 1) {

            this._accesoFormularios(1); // FW

            // configuracionGlobal.width = "60%";
            // configuracionGlobal.height = "30%";

            // const dialogRef1 = this.dialog.open(ModalAccesoComponent,configuracionGlobal);

            // dialogRef1.afterClosed().subscribe(result1 => {

            //   if(result1 != null)
            //   {

            //     dataResult = result1;

            //

            //   }

            // });

          }

        });

        break;

      case 3:

        this._accesoFormularios(1); // FW

        break;

      default:
        break;
    }


  }

  _descargarPdf() {

    // window.open(this.strDscLinkInst, '_blank');
    // let dscNombre = "instrucciones.pdf";
    const dscNombre = docInstrucciones;

    saveContent(rutaDocs + dscNombre, dscNombre);

  }

  _continuar() {

    this._resetFlags();

    // this.flgViewAcceda = true;

    cambiarRouter(this.router, 2);

  }

  _accedaDenuncia(fur: Fur) {

    this._denuncia(1); // MUESTRA PANEL DE DENUNCIA

    // if(fur.nfurIdestado == NumIdEstadoBorrador)
    // {

    //   fur.flgRecupBorrador = true;

    // }else{

    //   fur.flgRecupBorrador = false;

    // }


    setTimeout(() => {

      this.FormularioWebC.consultarDatosFur(fur);

    }, 1);

  }

  _salirFormulario() {

    this._resetFlags();

    this.flgViewPP = true;

  }

  // _linkFooter(numCaso:number)
  // {

  //   switch (numCaso) {
  //     case 1:

  //       break;

  //     default:
  //       break;
  //   }



  // }

  _seguimiento() {

    const configuracionGlobal = new MatDialogConfig();

    configuracionGlobal.disableClose = true;
    configuracionGlobal.autoFocus = true;

    configuracionGlobal.width = '80%';

    configuracionGlobal.data = {
      strDscLink : this.strDscEnlaceApp

    };

    this.dialog.open(ModalSeguimientoPpComponent, configuracionGlobal);

  }

}
